import createTableStore from "ds/components/Table/store/useTableStore";

import {
  VCS_INTEGRATION_USED_BY_TABLE_COLUMNS_CONFIG,
  VCS_INTEGRATION_USED_BY_TABLE_STORAGE_KEY,
} from "./constants";

const useVCSIntegrationUsedByTableStore = createTableStore({
  storageKey: VCS_INTEGRATION_USED_BY_TABLE_STORAGE_KEY,
  config: VCS_INTEGRATION_USED_BY_TABLE_COLUMNS_CONFIG,
});

export default useVCSIntegrationUsedByTableStore;
